export default __webpack_public_path__ + "singleband-dark.svg";